import Vue from 'vue'
import Vuex from 'vuex'
import LoginModule from './login'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login: LoginModule
  }
})
